<div
    class="hstack"
    [ngClass]="{
        'list-group-item-light': styleVariant === 'secondary'
    }"
>
    @if (iconSrc) {
        <div class="me-3">
            <img
                [ngSrc]="iconSrc"
                width="22"
                height="22"
                alt="icon"
            />
        </div>
    }
    <div
        class="p-1 vstack gap-0"
        [ngClass]="{
            'text-body': styleVariant === 'secondary',
        }"
    >
        <div class="hstack gap-3 align-items-center flex-grow-1">
            <span class="fw-semibold fs-4">
                {{ title }}
            </span>
            <span
                *ngIf="badgeText"
                class="badge"
                [ngClass]="'text-bg-' + badgeVariant"
            >
                {{ badgeText }}
            </span>
        </div>
        <div class="hstack gap-2 align-items-center">
            @if (subtitleIcon) {
                <img
                    ngSrc="{{ subtitleIcon }}"
                    width="16"
                    height="16"
                    alt="subtitle icon"
                />
            }
            @if (subtitle) {
                <span
                    class="text-body fs-3"
                    [innerText]="subtitle"
                >
                </span>
            }
        </div>
    </div>
    <div class="hstack gap-2">
        <div class="hstack gap-2 align-items-center">
            @if (descriptionIcon) {
                <img
                    ngSrc="{{ descriptionIcon }}"
                    width="16"
                    height="16"
                    alt="description icon"
                />
            }
            <ng-content select="[description]"></ng-content>
            <span
                *ngIf="description"
                class="fw-semibold text-body"
                [innerText]="description"
            >
            </span>
        </div>
        <span
            class="bi bi-chevron-right"
            [ngClass]="{
                'text-body': styleVariant === 'secondary',
            }"
        >
        </span>
    </div>
</div>
